import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, MapPin, Users, Briefcase } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

const Seminaires = () => {
  const { language } = useLanguage();

  const seminaires = [
    {
      date: '15 Janvier 2026',
      title: language === 'fr' ? 'Marco Polo : The Future of IT Solutions' : 'Marco Polo: The Future of IT Solutions',
      location: 'Paris - Hôtel Alfred Sommier',
      type: 'Séminaire Privé',
      description: language === 'fr'
        ? 'Séminaire privé réservé aux dirigeants d\'entreprises IT et aux éditeurs informatiques. Conférence exclusive avec des experts internationaux sur le marché IT en Chine.'
        : 'Private seminar reserved for IT company executives and software publishers. Exclusive conference with international experts on the IT market in China.',
      participants: '40-45 personnes',
      intervenants: ['Sara TIAN (JP Morgan China)', 'Yue JIN (Comité gouvernemental)', 'Gérald Karsenti (SAP France)'],
      status: 'available',
      link: '/member/seminaire-marco-polo'
    }
  ];

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-secondary)' }}>
      {/* Header */}
      <div style={{
        background: 'var(--bg-primary)',
        borderBottom: '1px solid var(--border-light)',
        padding: '32px 40px'
      }}>
        <div className="container" style={{ maxWidth: '1400px' }}>
          <Link to="/member/dashboard" style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            marginBottom: '16px',
            color: 'var(--text-secondary)',
            textDecoration: 'none',
            fontSize: '14px'
          }}>
            <ArrowLeft size={16} />
            {language === 'fr' ? 'Retour au tableau de bord' : 'Back to dashboard'}
          </Link>
          <h1 className="hero-medium">
            {language === 'fr' ? 'Séminaires Privés d\'Affaires' : 'Private Business Seminars'}
          </h1>
          <p className="body-regular" style={{ color: 'var(--text-secondary)', marginTop: '8px' }}>
            {language === 'fr' 
              ? 'Événements exclusifs réservés aux membres du Club Henry & Gaby' 
              : 'Exclusive events reserved for Henry & Gaby Club members'}
          </p>
        </div>
      </div>

      {/* Séminaires List */}
      <section className="section-padding">
        <div className="container">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(450px, 1fr))',
            gap: '32px'
          }}>
            {seminaires.map((seminaire, index) => (
              <div
                key={index}
                className="hover-lift"
                style={{
                  background: 'var(--bg-primary)',
                  border: '1px solid var(--border-light)',
                  overflow: 'hidden',
                  position: 'relative'
                }}
              >
                {/* Séminaire Header */}
                <div style={{
                  padding: '32px 28px 24px 28px',
                  borderBottom: '1px solid var(--border-light)',
                  background: 'linear-gradient(135deg, rgba(44, 95, 125, 0.05) 0%, rgba(255, 254, 242, 1) 100%)'
                }}>
                  {/* Type Badge */}
                  <div style={{
                    display: 'inline-block',
                    padding: '6px 12px',
                    background: '#2c5f7d',
                    color: 'var(--bg-primary)',
                    fontSize: '11px',
                    fontWeight: 600,
                    letterSpacing: '0.5px',
                    textTransform: 'uppercase',
                    marginBottom: '16px'
                  }}>
                    {seminaire.type}
                  </div>

                  {/* Title */}
                  <h3 className="heading-1" style={{ 
                    marginBottom: '16px',
                    lineHeight: 1.3
                  }}>
                    {seminaire.title}
                  </h3>

                  {/* Date & Location */}
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px'
                  }}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}>
                      <Calendar size={16} color="var(--text-secondary)" />
                      <span className="body-regular" style={{ color: 'var(--text-secondary)', fontWeight: 600 }}>
                        {seminaire.date}
                      </span>
                    </div>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}>
                      <MapPin size={16} color="var(--text-secondary)" />
                      <span className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                        {seminaire.location}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Séminaire Details */}
                <div style={{ padding: '28px' }}>
                  {/* Description */}
                  <p className="body-regular" style={{ 
                    color: 'var(--text-secondary)',
                    lineHeight: 1.7,
                    marginBottom: '20px',
                    paddingBottom: '20px',
                    borderBottom: '1px solid var(--border-light)'
                  }}>
                    {seminaire.description}
                  </p>

                  {/* Participants */}
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    marginBottom: '16px'
                  }}>
                    <Users size={18} color="var(--text-secondary)" />
                    <span className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                      {seminaire.participants}
                    </span>
                  </div>

                  {/* Intervenants */}
                  <div style={{ marginBottom: '24px' }}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      marginBottom: '12px'
                    }}>
                      <Briefcase size={18} color="var(--text-secondary)" />
                      <span className="body-regular" style={{ 
                        fontWeight: 600,
                        color: 'var(--text-primary)'
                      }}>
                        {language === 'fr' ? 'Intervenants :' : 'Speakers:'}
                      </span>
                    </div>
                    <ul style={{ 
                      listStyle: 'none', 
                      padding: 0,
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '6px',
                      marginLeft: '26px'
                    }}>
                      {seminaire.intervenants.map((intervenant, idx) => (
                        <li key={idx} style={{ 
                          display: 'flex', 
                          alignItems: 'flex-start',
                          gap: '8px'
                        }}>
                          <span style={{ color: '#2c5f7d', marginTop: '2px' }}>•</span>
                          <span className="body-small" style={{ color: 'var(--text-secondary)' }}>
                            {intervenant}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Discover Button */}
                  <Link 
                    to={seminaire.link}
                    className="btn-primary" 
                    style={{ 
                      width: '100%',
                      justifyContent: 'center',
                      textDecoration: 'none',
                      display: 'flex'
                    }}
                  >
                    {language === 'fr' ? 'Découvrir' : 'Discover'}
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section className="section-padding-small" style={{ background: 'var(--bg-primary)' }}>
        <div className="container" style={{ maxWidth: '900px', textAlign: 'center' }}>
          <h3 className="heading-1" style={{ marginBottom: '16px' }}>
            {language === 'fr' ? 'Séminaires Marco Polo Business Vision' : 'Marco Polo Business Vision Seminars'}
          </h3>
          <p className="body-regular" style={{ 
            color: 'var(--text-secondary)', 
            lineHeight: 1.8 
          }}>
            {language === 'fr'
              ? 'Les séminaires Marco Polo Business Vision sont des événements exclusifs organisés par le Club Henry & Gaby pour faciliter les relations d\'affaires entre la France et l\'Asie. Réservés aux dirigeants et décideurs, ces séminaires offrent un accès privilégié à des experts internationaux et des opportunités de networking de haut niveau.'
              : 'The Marco Polo Business Vision seminars are exclusive events organized by the Henry & Gaby Club to facilitate business relations between France and Asia. Reserved for executives and decision-makers, these seminars offer privileged access to international experts and high-level networking opportunities.'}
          </p>
        </div>
      </section>
    </div>
  );
};

export default Seminaires;
